import { initialListPaginationMeta } from "utils/helpers/pagination";

import { adminManagementState, adminManagementTableRow } from "../types";

export const initialState: adminManagementState = {
    statusFilter:  "ALL",
    data:           [] as adminManagementTableRow[],
    page:           1,
    perPage:        20,
    meta:           initialListPaginationMeta,
    isLoading:      false,
    error:          null,
    newUserForm: {
      fullName:   "",
      email:      "",
      role:       "",
      mobileNumber: "",
      department: "",
    },
    isAddModalOpen: false,
    userDetailes:   null,
}